// extracted by mini-css-extract-plugin
export default {"shimmer":"Loader_shimmer__lfoLC","dark_shimmer":"Loader_dark_shimmer__hwOQG","loader":"Loader_loader__uy4ge","blink":"Loader_blink__g-grn"};